import { combineReducers } from 'redux';
import uiReducer from './uiReducer';
import userPreferencesReducer from './userPreferencesReducer';
import userReducer from './userReducer';
import paymentReducer from './paymentReducer';
import userProductReducer from './userProductReducer';
import promoReducer from './promoReducer';
import ticketReducer from './ticketReducer';
import emailSubscriptionReducer from './emailSubscriptionReducer';
import shareWithFriendReducer from './shareWithFriendReducer';
import bookingManagementReducer from './bookingManagementReducer';
import activeCampaign from './activeCampaign'

const rootReducer = combineReducers({
  ui: uiReducer,
  userPreferences: userPreferencesReducer,
  user: userReducer,
  payment: paymentReducer,
  userProduct: userProductReducer,
  promo: promoReducer,
  validation: ticketReducer,
  emailSubscription: emailSubscriptionReducer,
  shareWithFriend: shareWithFriendReducer,
  bookingManagement: bookingManagementReducer,
  activeCampaign: activeCampaign
});

export default rootReducer;
